/**
 * Validates that a link is a safe internal (relative) path.
 * Rejects nulls, non-strings, protocol-based URLs, and double-slash prefixes.
 */
export function isValidInternalLink(link) {
  if (!link || typeof link !== 'string') return false;
  return link.startsWith('/') && !link.includes('://') && !link.startsWith('//');
}
